import _ from 'lodash'

export function cleanEntityTaxes (entity, menuBlob) {
  if (!_.has(entity, 'taxes.selected')) return

  const availableTaxes = menuBlob.taxStructures.map(next => next.id)
  entity.taxes.selected = entity.taxes.selected.filter(next => availableTaxes.includes(next.id))
}
